<template>
  <div class="container">
    <h1>User Information</h1>
    <div class="info-text-parent">
      <p>
        Name: <b>{{ user.name }}</b><br/>
        Email: <b>{{ user.email }}</b><br/>
      </p>
      <p>
        More information about your account on <a href="https://digital.swisscom.com/my/account" target="_blank">Digital
        Marketplace</a>.
      </p>
    </div>
  </div>
</template>

<script>
import userService from '@/services/user.service';
import {logger} from "@/services/logger.service";

export default {
  data() {
    return {
      user: [],
    };
  },
  async created() {
    await this.loadUserInformation();
  },
  methods: {
    async loadUserInformation() {
      this.user = await userService.getLoggedInUser();
      logger.debug(this.user)
    },
  },
};
</script>

<style>
.dotted-underline-info {
  border-bottom: 2px black dotted;
}
</style>
